// Upsells to someone who already pays: the Basic -> Creator sheet
// (components/upsell/CreatorUpsellSheet) and the Pro Coin packs
// (components/modals/CreditPackModal).
// See messages/README.md for how to add strings.
//
// Prices arrive already formatted as {price}; {files} is a count and
// {duration} is "2 min 5 s" (units left as they are, they read the same in
// es/pt). Pack prices in CreditPackModal are fixed USD strings, not here.
export const upsell = {
  en: {
    // Creator sheet, per reason: headline, lead, ticks, button.
    "upsell.creator.train.title": "Start training with Creator",
    "upsell.creator.train.lead": "Training a voice comes with Creator.",
    "upsell.creator.train.tick1": "Train unlimited voices",
    "upsell.creator.train.tick2": "Marble Run videos, 50 coins a month",
    "upsell.creator.train.tick3": "Everything in your plan stays",
    "upsell.creator.train.cta": "Upgrade and start training",

    "upsell.creator.export.title": "Export in 1080p",
    "upsell.creator.export.lead": "Creator exports your videos in full 1080p.",
    "upsell.creator.export.tick1": "1080p exports",
    "upsell.creator.export.tick2": "Marble Run videos, 50 coins a month",
    "upsell.creator.export.tick3": "Train unlimited voices",
    "upsell.creator.export.cta": "Upgrade and export in 1080p",

    "upsell.creator.marble.title": "Marble Run is on Creator",
    "upsell.creator.marble.lead":
      "Turn covers into Marble Run videos, ready for TikTok and Reels.",
    "upsell.creator.marble.tick1": "50 Marble Run coins every month",
    "upsell.creator.marble.tick2": "1080p studio exports",
    "upsell.creator.marble.tick3": "Train unlimited voices",
    "upsell.creator.marble.cta": "Upgrade and make a Marble Run",

    "upsell.creator.video.title": "Videos are on Creator",
    "upsell.creator.video.lead":
      "Turn your covers into shareable videos for TikTok and Reels.",
    "upsell.creator.video.tick1": "Shareable videos, 50 coins a month",
    "upsell.creator.video.tick2": "1080p studio exports",
    "upsell.creator.video.tick3": "Train unlimited voices",
    "upsell.creator.video.cta": "Upgrade and make my video",

    // Creator sheet, shared.
    "upsell.creator.samplesOne":
      "Your vocals are ready: {files} file, {duration}. ",
    "upsell.creator.samplesMany":
      "Your vocals are ready: {files} files, {duration}. ",
    "upsell.creator.nothing": "Nothing",
    "upsell.creator.today": "today",
    "upsell.creator.toPayToday": "to pay today",
    "upsell.creator.thenMonth": "then {price} a month",
    "upsell.creator.credited":
      "The rest of your current month is credited. Cancel any time.",
    "upsell.creator.priceError":
      "We couldn't load your upgrade price. You can upgrade any time from Settings.",
    "upsell.creator.upgrading": "Upgrading...",
    "upsell.creator.notNow": "Not now",
    "upsell.creator.payFailed":
      "The payment didn't go through, so nothing changed. Check your card in Settings and try again.",

    // Pro Coin packs.
    "upsell.coins.title": "Get Pro Coins",
    "upsell.coins.subtitle": "Each coin creates one shareable video",
    "upsell.coins.coinAlt": "Pro Coin",
    "upsell.coins.useMarble": "Marble Run Videos",
    "upsell.coins.useLyric": "Lyric Videos",
    "upsell.coins.useTemplates": "All Video Templates",
    "upsell.coins.bestValue": "BEST VALUE",
    "upsell.coins.mostCoins": "MOST COINS",
    "upsell.coins.proCoins": "pro coins",
    "upsell.coins.each": "{price}/each",
    "upsell.coins.purchase": "Purchase",
    "upsell.coins.footer":
      "Pro Coins are added instantly and never expire. 1 coin = 1 video.",
  },
};
